<div class="container">
  <ppl-avatar
    entity="client"
    size="32"
    [forceRound]="true"></ppl-avatar>
  <div class="user-info">
    @if (user.name) {
      <div
        [title]="user.name"
        class="user-name">
        {{ user.name }}
      </div>
    }
    <div
      [title]="user.email"
      class="user-email">
      {{ user.email }}
    </div>
  </div>
  <ppl-icon
    svgIcon="edit-white"
    height="18px"
    width="18px"
    class="edit"
    (mousedown)="onEdit($event)"></ppl-icon>
</div>
